import React from 'react';

const organizationListItem: React.FunctionComponent<any> = ({organization, onClick}) => {
  return (
    <div className="flex items-center border border-white mb-2.5 md:mb-6 px-0.5 py-4 h-28 cursor-pointer" onClick={() => onClick(organization)}>
      <div className="flex-1 pl-4 font-bold">
        <span className="font-bruno text-xl block leading-none">{organization.organization_name}</span>
        <span className="font-overpass-mono font-bold text-sm block mt-2">{organization.address}</span>
      </div>
      <button className="text-3xl mr-3">
        <svg width="14px" height="56px" viewBox="0 0 14 56" version="1.1" xmlns="http://www.w3.org/2000/svg">
            <g id="Symbols" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" strokeLinecap="round">
                <g id="Location/Pilot" transform="translate(-383.000000, -24.000000)" stroke="#FFFFFF">
                    <polyline id="Path" transform="translate(390.026369, 51.846837) rotate(-90.000000) translate(-390.026369, -51.846837) " points="362.201812 45.4972437 390.5 58.1964294 417.850926 45.4972437"></polyline>
                </g>
            </g>
        </svg>
      </button>
    </div>
  )
}

export default organizationListItem;